import { CheckCircle2 } from "lucide-react";
import { useTranslation } from "react-i18next";

const HowItWorksSection = () => {
    const { t } = useTranslation();

    const steps = [
        {
            title: t('landing.howItWorks.step1.title'),
            description: t('landing.howItWorks.step1.desc'),
            features: [t('landing.howItWorks.step1.f1'), t('landing.howItWorks.step1.f2'), t('landing.howItWorks.step1.f3')],
        },
        {
            title: t('landing.howItWorks.step2.title'),
            description: t('landing.howItWorks.step2.desc'),
            features: [t('landing.howItWorks.step2.f1'), t('landing.howItWorks.step2.f2'), t('landing.howItWorks.step2.f3')],
        },
        {
            title: t('landing.howItWorks.step3.title'),
            description: t('landing.howItWorks.step3.desc'),
            features: [t('landing.howItWorks.step3.f1'), t('landing.howItWorks.step3.f2'), t('landing.howItWorks.step3.f3')],
        },
        {
            title: t('landing.howItWorks.step4.title'),
            description: t('landing.howItWorks.step4.desc'),
            features: [t('landing.howItWorks.step4.f1'), t('landing.howItWorks.step4.f2'), t('landing.howItWorks.step4.f3')],
        },
    ];

    return (
        <section id="how-it-works" className="py-24 bg-background relative overflow-hidden animate-fade-up">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center max-w-3xl mx-auto mb-20 animate-fade-up">
                    <span className="text-african-accent font-bold tracking-wider uppercase text-sm">{t('landing.howItWorks.badge')}</span>
                    <h2 className="font-display text-4xl sm:text-5xl font-bold mt-4 mb-6">
                        {t('landing.howItWorks.title')} <span className="text-african-accent">{t('landing.howItWorks.titleAccent')}</span>
                    </h2>
                    <p className="text-xl text-muted-foreground">
                        {t('landing.howItWorks.subtitle')}
                    </p>
                </div>

                <div className="grid lg:grid-cols-4 gap-8">
                    {steps.map((step, index) => (
                        <div key={index} className="relative group animate-fade-up" style={{ animationDelay: `${index * 0.15}s` }}>
                            {/* Step Number */}
                            <div className="w-12 h-12 bg-african-accent text-white rounded-xl flex items-center justify-center font-display font-bold text-xl mb-6 shadow-African group-hover:scale-110 transition-transform duration-300">
                                {index + 1}
                            </div>

                            {/* Connector Line (Desktop) */}
                            {index < steps.length - 1 && (
                                <div className="hidden lg:block absolute top-6 left-12 w-full h-[2px] bg-african-accent/10 -z-10" />
                            )}

                            <h3 className="text-xl font-bold mb-4">{step.title}</h3>
                            <p className="text-muted-foreground mb-6">
                                {step.description}
                            </p>

                            <ul className="space-y-3">
                                {step.features.map((feature, fIndex) => (
                                    <li key={fIndex} className="flex items-center gap-2 text-sm text-foreground/80">
                                        <CheckCircle2 size={16} className="text-african-accent" />
                                        {feature}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default HowItWorksSection;
